﻿package com.mgacreative.hotel.feature.ai_assistant.domain

import com.mgacreative.hotel.core.tenant.TenantSession

data class ChatMessage(
    val id: String,
    val role: String, // "user", "assistant"
    val content: String
)

// Acceptance Criteria: Sadece önceden tanımlanmış fonksiyonlar çalıştırılır, serbest SQL yasaktır.
class HotelTools(private val tenantSession: TenantSession) {
    
    // Acceptance Criteria: Her araç yalnızca mevcut tenantSession.currentTenantId kullanır.
    fun getAvailableRooms(): String {
        val tenantId = tenantSession.currentTenantId
        // Mock DB query restricted by tenantId
        return "Åu anda $tenantId otelinde 12 adet oda boştur. (Kategoriler: 5 Standart, 5 Deluxe, 2 Suit)"
    }

    fun getMonthlyRevenue(): String {
        val tenantId = tenantSession.currentTenantId
        return "$tenantId otelinin bu ayki toplam geliri: 125,000 TL."
    }

    fun getTopGuests(): String {
        val tenantId = tenantSession.currentTenantId
        return "$tenantId otelinde en çok konaklayan misafirler: 1. Ahmet Yılmaz (5 Konaklama), 2. Mehmet Kaya (3 Konaklama)."
    }

    fun getPendingHousekeeping(): String {
        val tenantId = tenantSession.currentTenantId
        return "$tenantId otelinde şu an temizlik bekleyen oda sayısı 3'tür (Oda 101, 105, 203)."
    }
}

